import PropTypes from 'prop-types';
import React from 'react';

export class MoreButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div
        className="u-taCenter u-clickable u-bgColorGrayLightest u-p2x"
        style={{
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
        onClick={this.props.onClick}
      >
        <a
          className="u-p2x u-tcGrayDark u-fw500 u-letterSpacing1 u-textUppercase"
          style={{ fontSize: '10px' }}
        >
          Show More
        </a>
      </div>
    );
  }
}
